<template>
  <v-navigation-drawer
    class="elevation-8"
    disable-resize-watcher
    :width="rightSidebarWidth"
    right
    absolute
    stateless
    hide-overlay
    v-model="showPredefinedBookmarks"
    color="whitesmoke"
  >
    <v-toolbar
      flat
      style="position: -webkit-sticky; /* Safari */position: sticky; z-index: 3"
    >
      <v-btn icon @click="hideCatalogueDrawer">
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-toolbar-title>Risikoobjekter</v-toolbar-title>
      <!-- <v-subheader v-if="currentlyOpenedProject">{{
        currentlyOpenedProject.attributes.tittel
      }}</v-subheader> -->

      <v-spacer></v-spacer>
    </v-toolbar>

    <!-- <v-text-field
      v-model="search"
      label="Søk etter risikoobjekter.."
      flat
      box
      single-line
      hide-details
      clearable
      clear-icon="mdi-close-circle-outline"
    ></v-text-field> -->
    <!-- <p class="secondary pl-3 pr-4 pt-2 pb-2 mb-0">
      Dra kartlag fra kartkatalogen og slipp i kartet for å legge til.
    </p> -->
    <v-sheet
      class="mx-auto"
      style="overflow-y: scroll; height: calc(100% - 64px); overflow-x: auto"
      height="100%"
    >
      <!-- <v-btn
        @click="close"
        color="blue"
        absolute
        top
        right
        style="margin-top: 30px;"
        fab
        small
      >
        <v-icon color="white">close</v-icon>
      </v-btn> -->

      <v-treeview
        class="pa-2"
        return-object
        :search="search"
        open-on-click
        open-all
        :items="categoriesSortedAsArray"
      >
        <template v-slot:prepend="{ item, open }">
          <!-- <draggable
            :list="categoriesSortedAsArray"
            @end="checkEnd"
            :sort="false"
          > -->
          <v-icon v-if="item.children">
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
          <v-icon v-else @click="goToBookmark(item)">
            mdi-map-marker-outline
          </v-icon>
          <!-- </draggable> -->
        </template>
        <template slot="label" slot-scope="{ item }">
          <a class="caption black--text" @click="goToBookmark(item)">{{
            item.name
          }}</a>
        </template>
      </v-treeview>
    </v-sheet>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ProfilesMixin from "@/mixins/profilesMixin";
import { loadModules } from "esri-loader";
import { importBookmarksFile } from "../../../../mixins/layerLogic.js";

export default {
  name: "MapPredefinedBookmarks",
  mixins: [ProfilesMixin],
  computed: {
    ...mapState(["is3d"]),
    rightSidebarWidth() {
      if (this.$vuetify.breakpoint.xlAndUp) {
        return "440";
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return "420";
      } else if (this.$vuetify.breakpoint.mdAndUp) {
        return "350";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "300";
      } else {
        return "300";
      }
    },
    showPredefinedBookmarks: {
      set(showPredefinedBookmarks) {
        this.setShowPredefinedBookmarks(showPredefinedBookmarks);
      },
      get() {
        return this.$store.state.showPredefinedBookmarks;
      }
    }
  },
  data: function() {
    return {
      categoriesSortedAsArray: [],
      search: null,
      loaded: false
    };
  },
  methods: {
    ...mapActions(["setShowPredefinedBookmarks", "setSnack"]),
    hideCatalogueDrawer() {
      this.setShowPredefinedBookmarks(false);
    },
    goToBookmark(item) {
      if (item.hasOwnProperty("children")) {
        return;
      }
      return loadModules(["esri/geometry/Point"]).then(([Point]) => {
        let target = new Point({
          x: item.x,
          y: item.y,
          type: "point",
          spatialReference: { wkid: 25833 }
        });
        if (this.is3d) {
          this.$theSceneViewObject.goTo({
            target: target,
            zoom: 13
          });
        } else {
          // if (bookmark.hasOwnProperty("camera")) {
          //   this.bookmark3dTemporary = bookmark;
          //   this.confirmOpen3dBookmarkDialog = true;
          // } else {
          this.$theMapViewObject.goTo({
            target: target,
            zoom: 13
          });
          // this.setSnack("Åpnet bokmerke " + bookmark.title);
          // }
        }
        this.setSnack("Går til " + item.name);
      });
    }
  },
  mounted: function() {
    importBookmarksFile().then(result => {
      this.categoriesSortedAsArray = result.bookmarks;
    });
  },
  created() {}
};
</script>

<style></style>
